import axios from "axios"

export default {
  getCourseOptions: function () {
    return axios.get("/get-dropdown-options/8")
  },
  getSectionOptions: function (course_id: any) {
    return axios.get("/sections-by-course/" + course_id)
  },
  getBundleWithLimit10: function (query:string) {
    let q = (query && query.length >= 2) ? query : 'a'
    let url = 'bundle_packages/with-limit-10/?q=' + q
    return axios.get(url);
  },
  getCourseWithLimit10: function (query:string) {
    let q = (query && query.length >= 2) ? query : 'a'
    let url = 'courses/with-limit-10/?q=' + q
    return axios.get(url);
  },
};
